export const defaultTranslationsStatus = {
  isReady: false
};